// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"462":"a86a5406","765":"cde62e4d"}[chunkId] + ".chunk.css";
};